import AsyncSelect from "react-select/async";
import { SearchFieldStyles } from "./SearchFieldStyles";
import servBairros from "../../services/login/servBairros";

const BairrosSearchField = ({ field, id, setOpenError, setErrorMessage, disabled = false, onKeyDown, className = "", watchCodigoCidade, tipoKey, setOpen }) => {

  const loadBairros = async (inputValue) => {
    try {
      if (!watchCodigoCidade?.value) return [];

      const response = await servBairros.listar(inputValue, watchCodigoCidade?.value);

      let data = response.Content.map(mapResponseToValuesAndLabels);

      return data;

    } catch (err) {
      setOpen(true);
      setOpenError(true);
      setErrorMessage(err?.response?.data?.Message);
    }
  }

  const mapResponseToValuesAndLabels = (data) => {
    return {
      value: data.Id,
      label: data.Nome,
      codigoRegiao: data.CodigoRegiao
    }
  }

  return (
    <AsyncSelect
      key={tipoKey}
      id={id}
      cacheOptions
      placeholder="Selecione um bairro"
      loadOptions={loadBairros}
      defaultOptions
      isDisabled={disabled}
      styles={SearchFieldStyles}
      {...field}
      onKeyDown={onKeyDown}
      className={className}
    />
  )
}

export { BairrosSearchField }